/**
 * Get the last "current" drawing with category "1"
 * @param {Array} drawings
 */
export const getCurrentDrawing = drawings => {
    return [...drawings]
        .reverse()
        .find(
            drawing =>
                drawing.draw_status === 'current' &&
                parseInt(drawing.category, 10) === 1
        );
};
